import React from 'react';
import Reveal from '../ui/Reveal';

const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-offwhite relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Text Content */}
          <div className="order-2 lg:order-1">
            <Reveal direction="right">
              <h2 className="font-serif text-4xl md:text-5xl text-navy-900 mb-8 leading-tight">
                In a world driven by narratives, the power lies in <span className="italic text-gold-600">shaping them with purpose.</span>
              </h2>
            </Reveal>
            
            <Reveal delay={0.2} direction="right">
              <p className="text-gray-600 text-lg mb-6 font-light leading-relaxed">
                Page1News is not just a PR agency; we are a literary powerhouse operating at the intersection of media, culture, and credibility. We believe every brand has a soul, and our mission is to articulate it with unmatched clarity and authority.
              </p>
              <p className="text-gray-600 text-lg mb-10 font-light leading-relaxed">
                Led by author and media personality Romita Khurana Sahni, our approach is intuitive, editorial, and unapologetically bold. We craft campaigns that command attention and secure your place on the front page of your industry.
              </p>
            </Reveal>

            <Reveal delay={0.4} direction="up">
              <div className="flex border-l-2 border-gold-500 pl-6 py-2">
                <p className="font-serif text-xl text-navy-800 italic">
                  "PR with a Literary Soul."
                </p>
              </div>
            </Reveal>
          </div>

          {/* Image Grid */}
          <div className="order-1 lg:order-2 relative">
            <Reveal direction="left">
              <div className="relative h-[500px] w-full md:w-4/5 ml-auto">
                <img 
                  src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?q=80&w=1000&auto=format&fit=crop" 
                  alt="Editorial workspace" 
                  className="w-full h-full object-cover shadow-2xl grayscale hover:grayscale-0 transition-all duration-700"
                />
                {/* Decorative Elements */}
                <div className="absolute -bottom-6 -left-6 md:-left-12 w-48 h-48 bg-gold-500 -z-10"></div>
                <div className="absolute -top-6 -right-6 w-32 h-32 border border-navy-900 -z-10"></div>
              </div>
            </Reveal>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;